import { BaseApi } from '@shared/config';
import {
  type SignInRequest,
  type SignInResponse,
  type User,
  type RecoveryPasswordRequest,
  type RecoveryPasswordResponse,
  type ResetPasswordRequest,
  type ResetPasswordResponse,
  type RegisterRequest,
  type RegisterResponse,
  type VerifyEmailRequest,
  type VerifyEmailResponse,
} from './types';

class AuthApi extends BaseApi {
  private readonly basePrefix = 'authentication';

  async signIn(data: SignInRequest): Promise<SignInResponse> {
    return this.instance.post(`authentication/admin/authenticate`, data);
  }

  async getMe(): Promise<User> {
    return this.instance.get(`${this.basePrefix}/me`);
  }

  async recoveryPassword(
    data: RecoveryPasswordRequest
  ): Promise<RecoveryPasswordResponse> {
    return this.instance.post(
      `${this.basePrefix}/recovery/password/request`,
      data
    );
  }

  async resetPassword(
    data: ResetPasswordRequest
  ): Promise<ResetPasswordResponse> {
    return this.instance.post(
      `${this.basePrefix}/recovery/password/reset`,
      data
    );
  }

  async signOut(): Promise<void> {
    return this.instance.post(`${this.basePrefix}/logout`);
  }

  async register(data: RegisterRequest): Promise<RegisterResponse> {
    return this.instance.post(`${this.basePrefix}/register`, data);
  }

  async verifyEmail(data: VerifyEmailRequest): Promise<VerifyEmailResponse> {
    return this.instance.post(`${this.basePrefix}/verify`, data);
  }
}

export const authApi = new AuthApi();
